import { Modal, Text, Button, Stack } from "@mantine/core";
import { cedisLocale } from "../../helpers/utilities";

/**
 * CheckoutConfirmation component
 *
 * Props:
 * - isOpen: boolean - whether the confirmation modal is open
 * - onClose: function - callback when modal is closed
 * - onConfirm: function - callback when user confirms checkout
 * - billData: object - bill data for summary display
 * - totalDue: number - total amount due
 * - totalPayments: number - total payments made
 * - balance: number - balance amount
 * - isLoading: boolean - whether checkout is in progress
 */
export const CheckoutConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  billData,
  totalDue,
  totalPayments,
  balance,
  isLoading = false,
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title="Confirm Checkout"
      size="md"
      zIndex={100}>
      <div className="p-3">
        <div className="mb-3">
          <Text size="sm" weight={600} className="mb-2">
            Are you sure you want to checkout this bill?
          </Text>
          <Text size="xs" color="dimmed">
            This action will finalize the transaction and generate a receipt.
          </Text>
        </div>

        <div className="mb-3 p-3 bg-light rounded">
          <Text size="xs" weight={600} className="mb-2">
            Transaction Summary:
          </Text>

          <Stack spacing="xs">
            <div className="d-flex justify-content-between">
              <Text size="xs">Items:</Text>
              <Text size="xs" weight={500}>
                {billData?.items?.length || 0}
              </Text>
            </div>

            <div className="d-flex justify-content-between">
              <Text size="xs">Total Due:</Text>
              <Text size="xs" weight={500}>
                {cedisLocale.format(parseFloat(totalDue).toFixed(1))}
              </Text>
            </div>

            <div className="d-flex justify-content-between">
              <Text size="xs">Amount Paid:</Text>
              <Text size="xs" weight={500}>
                {cedisLocale.format(parseFloat(totalPayments).toFixed(1))}
              </Text>
            </div>

            <div className="d-flex justify-content-between">
              <Text size="xs" weight={600}>
                Balance:
              </Text>
              <Text
                size="xs"
                weight={600}
                color={balance > 0 ? "red" : balance < 0 ? "orange" : "green"}>
                {cedisLocale.format(parseFloat(balance).toFixed(1))}
              </Text>
            </div>
          </Stack>
        </div>

        {/* {billData?.redeemedBenefits?.length > 0 && (
          <div className="mb-3 p-2 bg-green-50 rounded border border-green-200">
            <Text size="xs" weight={600} color="green" className="mb-1">
              Value Utilized:
            </Text>
            <Text size="xs" color="green">
              {billData.redeemedBenefits.length} value(s) utilized
            </Text>
          </div>
        )} */}

        <div className="d-flex gap-2 justify-content-end">
          <Button
            variant="subtle"
            size="sm"
            onClick={onClose}
            disabled={isLoading}>
            Cancel
          </Button>
          <Button
            color="blue"
            size="sm"
            loading={isLoading}
            onClick={onConfirm}>
            Confirm Checkout
          </Button>
        </div>
      </div>
    </Modal>
  );
};
